import React from 'react';
import styled from 'styled-components';

const getItemTitle = item => item?.name || item?.nazev || item?.photoSourceTitle || '';

const PreviewFrame = styled.figure`
    display: grid;
    grid-template-columns: minmax(132px, 220px) minmax(0, 1fr);
    margin: 0;
    min-height: 132px;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    overflow: hidden;
    background: #fbfbfb;

    @media (max-width: 640px) {
        grid-template-columns: 1fr;
    }
`;

const PreviewImage = styled.img`
    display: block;
    width: 100%;
    height: 100%;
    min-height: 132px;
    max-height: 168px;
    object-fit: cover;
    background: #eeeeee;

    @media (max-width: 640px) {
        max-height: 190px;
    }
`;

const PreviewCaption = styled.figcaption`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 6px;
    min-width: 0;
    padding: 14px 16px;
    color: #737373;
    font-size: 12px;
    line-height: 1.45;

    a {
        color: inherit;
        text-decoration: underline;
    }
`;

const PreviewLabel = styled.span`
    color: #8c8c8c;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
`;

const PreviewTitle = styled.strong`
    color: #1f1f1f;
    font-size: 15px;
    line-height: 1.25;
`;

const Attribution = styled.span`
    overflow-wrap: anywhere;
`;

const ThumbnailFrame = styled.span`
    flex: 0 0 64px;
    width: 64px;
    height: 48px;
    display: inline-flex;
    border: 1px solid #e8e8e8;
    border-radius: 7px;
    overflow: hidden;
    background: #f5f5f5;
`;

const ThumbnailImage = styled.img`
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const PhotoAttribution = ({ item }) => {
    if (!item?.photoAttribution && !item?.photoLicense && !item?.photoFile) {
        return null;
    }

    return (
        <Attribution>
            Foto: {item.photoAttribution || 'neuvedeno'}
            {item.photoLicense ? ` • ${item.photoLicense}` : ''}
            {item.photoFile && (
                <>
                    {' • '}
                    <a
                        href={`https://commons.wikimedia.org/wiki/File:${item.photoFile}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Wikimedia Commons
                    </a>
                </>
            )}
        </Attribution>
    );
};

export const QuizPhotoPreview = ({ item, alt, label = 'Fotka k otázce', showTitle = true }) => {
    if (!item?.photo) return null;

    const title = getItemTitle(item);

    return (
        <PreviewFrame>
            <PreviewImage src={item.photo} alt={alt || title} loading="lazy" />
            <PreviewCaption>
                <PreviewLabel>{label}</PreviewLabel>
                {showTitle && title && <PreviewTitle>{title}</PreviewTitle>}
                <PhotoAttribution item={item} />
            </PreviewCaption>
        </PreviewFrame>
    );
};

export const QuizPhotoThumbnail = ({ item, alt }) => {
    if (!item?.photo) return null;

    return (
        <ThumbnailFrame>
            <ThumbnailImage src={item.photo} alt={alt || getItemTitle(item)} loading="lazy" />
        </ThumbnailFrame>
    );
};
